import React from 'react';
import { motion } from 'framer-motion';
import { Building2, UserCheck, Stethoscope } from 'lucide-react';
const objectives = [{
  icon: Building2,
  audience: 'For Solventum',
  title: 'Scalable engagement & enablement',
  description: 'A platform that delivers scalable engagement, sales enablement and clinical insight — Solventum shown in the moment it solved the case, never forced.'
}, {
  icon: UserCheck,
  audience: 'For the Clinicians (KOLs)',
  title: 'A premium educational stage',
  description: 'Visibility, authority and a peer-learnings platform. Real clinicians are presented as the experts behind every case.'
}, {
  icon: Stethoscope,
  audience: 'For Practitioners',
  title: 'Practical, case-based learning',
  description: 'Real restorative cases from diagnosis to technique to outcome — practical learning practitioners can apply chair-side the next day.'
}];
export function StrategicIntent() {
  return <section className="py-24 bg-white" data-id="element-340">
      <div className="max-w-6xl mx-auto px-6" data-id="element-341">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-342">
          <div className="text-xs font-semibold text-solventum-teal tracking-[0.2em] uppercase mb-4" data-id="element-343">
            The Idea
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-solventum-dark mb-3" data-id="element-344">
            Value for three audiences
          </h2>
          <p className="text-xl md:text-2xl font-medium text-solventum-dark/80 max-w-3xl mx-auto mb-3" data-id="element-345">
            One platform, three wins — Solventum, clinicians, and practitioners
          </p>
          <p className="text-lg text-solventum-dark/60 max-w-2xl mx-auto" data-id="element-346">
            Every design decision serves all three audiences simultaneously
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-347">
          {objectives.map((obj, index) => <motion.div key={obj.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-solventum-lightTeal/40 rounded-2xl p-8 border border-solventum-lightTeal hover:border-solventum-teal/50 transition-colors" data-id="element-348">
              <obj.icon className="w-10 h-10 text-solventum-teal mb-4" strokeWidth={1.5} data-id="element-349" />
              <div className="text-xs font-semibold text-solventum-teal tracking-wider uppercase mb-2" data-id="element-350">
                {obj.audience}
              </div>
              <h3 className="text-xl font-semibold text-solventum-dark mb-3" data-id="element-351">
                {obj.title}
              </h3>
              <p className="text-solventum-dark/70 leading-relaxed" data-id="element-352">
                {obj.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}